<template>
    <card class="spaced typo">
        
        <h2 class="text-white mb-4">
            {{ $t('xapi.common.agent-profiles') }}
        </h2>

        <form @submit.prevent @keydown="filters.errors.clear($event.target.name)">

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.profile-id') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.common.search.id-placeholder')"
                    v-model="filters.profileId"
                    name="profileId"
                    :error="filters.errors.get('profileId')">
                </base-input>
            </div>

            <div class="form-row">

                <label class="col-md-1 col-form-label text-md-right text-left pb-0">
                    {{ $t('xapi.common.agent-id') }}
                </label>

                <base-input class="col-md-11"
                    :placeholder="$t('xapi.statements.search.actor-placeholder')"
                    v-model="filters.agentId"
                    name="agentId"
                    :error="filters.errors.get('agentId')">
                </base-input>
            </div>

            <div class="text-center pt-1">
                <base-button type="primary" native-type="submit" @click="apply">
                    {{ $t('common.apply') }}
                </base-button>

                <base-button type="primary" native-type="submit" link @click="reset">
                    {{ $t('common.reset') }}
                </base-button>
            </div>

        </form>
    </card>
</template>

<script>
    export default {

        props: {
            scope: {
                type: String,
                default: null
            }
        },

        data() {
            return {
                loader: this.$xapi.loaders.agentProfiles,
                filters: this.$xapi.filters.agentProfiles,
            }
        },

        created() {
            this.$xapi.filters.agentProfiles.attach(this, this.scope)
        },

        methods: {

            apply() {
                this.loader.firstLoad()
            },

            reset() {
                this.filters.reset()
                this.loader.firstLoad()
            }
        }
    }
</script>
